function splitPhoneNumber(phoneNumber) {
  const regex10 = /^(\d{3})(\d{3})(\d{4})$/;
  const regex11 = /^(\d{3})(\d{4})(\d{4})$/;
  const regex = phoneNumber.length === 10 ? regex10 : regex11;
  return phoneNumber.match(regex);
}
export { splitPhoneNumber };
